import React from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';

import {
  PageBadgesList,
  PageBadge,
} from '../pages/badges';

const RouteBadges = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <PageBadgesList />
      </Route>
      <Route path={`${path}/:_id`}>
        <PageBadge />
      </Route>
    </Switch>
  );
};

export default RouteBadges;
